//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './InputTemplateClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetInputTemplateQueryParameters = {
  type?: Types.InputTemplateType | null | undefined ;
  subtenantId?: number | null | undefined ;
  dataBlockFieldId?: number | null | undefined ;
}

export type GetSingleInputTemplateQueryParameters = {
  id: number ;
}

export type PatchInputTemplateQueryParameters = {
  id: number ;
}

export type RemoveInputTemplateQueryParameters = {
  id: number ;
}

export function getUrl(type?: Types.InputTemplateType | null | undefined, subtenantId?: number | null | undefined, dataBlockFieldId?: number | null | undefined): string {
  let url_ = getBaseUrl() + "/api/input-templates?";
if (type !== undefined && type !== null)
    url_ += "Type=" + encodeURIComponent("" + type) + "&";
if (subtenantId !== undefined && subtenantId !== null)
    url_ += "SubtenantId=" + encodeURIComponent("" + subtenantId) + "&";
if (dataBlockFieldId !== undefined && dataBlockFieldId !== null)
    url_ += "DataBlockFieldId=" + encodeURIComponent("" + dataBlockFieldId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.InputTemplateDto[], unknown, Types.InputTemplateDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.InputTemplateDto[], unknown, Types.InputTemplateDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetInputTemplateQueryParameters): QueryKey;
export function getQueryKey(type?: Types.InputTemplateType | null | undefined, subtenantId?: number | null | undefined, dataBlockFieldId?: number | null | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { type, subtenantId, dataBlockFieldId,  } = params[0] as GetInputTemplateQueryParameters;

    return trimArrayEnd([
        'InputTemplateClient',
        'get',
        type as any,
        subtenantId as any,
        dataBlockFieldId as any,
      ]);
  } else {
    return trimArrayEnd([
        'InputTemplateClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as Types.InputTemplateType | null | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as number | null | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.InputTemplateDto[], TError = unknown>(dto: GetInputTemplateQueryParameters, options?: Omit<UseQueryOptions<Types.InputTemplateDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets input templates
 * @param type (optional) 
 * @param subtenantId (optional) 
 * @param dataBlockFieldId (optional) 
 */
export function useGetQuery<TSelectData = Types.InputTemplateDto[], TError = unknown>(type?: Types.InputTemplateType | null | undefined, subtenantId?: number | null | undefined, dataBlockFieldId?: number | null | undefined, options?: Omit<UseQueryOptions<Types.InputTemplateDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.InputTemplateDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.InputTemplateDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let type: any = undefined;
  let subtenantId: any = undefined;
  let dataBlockFieldId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ type, subtenantId, dataBlockFieldId,  } = params[0] as GetInputTemplateQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [type, subtenantId, dataBlockFieldId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.InputTemplateDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(type, subtenantId, dataBlockFieldId),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.InputTemplateDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets input templates
 * @param type (optional) 
 * @param subtenantId (optional) 
 * @param dataBlockFieldId (optional) 
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.InputTemplateDto[] | undefined) => Types.InputTemplateDto[], type?: Types.InputTemplateType | null | undefined, subtenantId?: number | null | undefined, dataBlockFieldId?: number | null | undefined) {
  queryClient.setQueryData(getQueryKey(type, subtenantId, dataBlockFieldId),
    updater
  );
}

/**
 * Gets input templates
 * @param type (optional) 
 * @param subtenantId (optional) 
 * @param dataBlockFieldId (optional) 
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.InputTemplateDto[] | undefined) => Types.InputTemplateDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/input-templates";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'InputTemplateClient',
      'create',
    ]);
}

/**
 * Creates an input template.
 * @param dto Request parameter
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.InputTemplateDto, unknown, Types.CreateInputTemplateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.InputTemplateDto, unknown, Types.CreateInputTemplateDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateInputTemplateDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getSingleUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/input-templates/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSingleDefaultOptions: Omit<UseQueryOptions<Types.InputTemplateDto, unknown, Types.InputTemplateDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.InputTemplateDto, unknown, Types.InputTemplateDto>, 'queryFn'>> = {
};
export function getGetSingleDefaultOptions() {
  return getSingleDefaultOptions;
};
export function setGetSingleDefaultOptions(options: typeof getSingleDefaultOptions) {
  getSingleDefaultOptions = options;
}

export function getSingleQueryKey(id: number): QueryKey;
export function getSingleQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetSingleInputTemplateQueryParameters;

    return trimArrayEnd([
        'InputTemplateClient',
        'getSingle',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'InputTemplateClient',
        'getSingle',
        ...params
      ]);
  }
}
export function __getSingle(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSingle(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetSingleQuery<TSelectData = Types.InputTemplateDto, TError = unknown>(dto: GetSingleInputTemplateQueryParameters, options?: Omit<UseQueryOptions<Types.InputTemplateDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets input template by id.
 */
export function useGetSingleQuery<TSelectData = Types.InputTemplateDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.InputTemplateDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSingleQuery<TSelectData = Types.InputTemplateDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.InputTemplateDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetSingleInputTemplateQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.InputTemplateDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSingle(context, axiosConfig) : __getSingle,
    queryKey: getSingleQueryKey(id),
    ...getSingleDefaultOptions as unknown as Omit<UseQueryOptions<Types.InputTemplateDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets input template by id.
 */
export function setGetSingleData(queryClient: QueryClient, updater: (data: Types.InputTemplateDto | undefined) => Types.InputTemplateDto, id: number) {
  queryClient.setQueryData(getSingleQueryKey(id),
    updater
  );
}

/**
 * Gets input template by id.
 */
export function setGetSingleDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.InputTemplateDto | undefined) => Types.InputTemplateDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/input-templates/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'InputTemplateClient',
      'patch',
      id as any,
    ]);
}

/**
 * Edits an input template.
 * @param id The input template id.
 * @param dto Request parameter
 */
export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.PatchInputTemplateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PatchInputTemplateDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchInputTemplateDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchInputTemplateQueryParameters & {
  dto: Types.PatchInputTemplateDto;
}

/**
 * Edits an input template.
 * @param id The input template id.
 * @param dto Request parameter
 */
export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchInputTemplateQueryParameters}): UseMutationResult<void, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/input-templates/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'InputTemplateClient',
      'remove',
      id as any,
    ]);
}

/**
 * Removes an input template.
 * @param id The input template id.
 */
export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveInputTemplateQueryParameters

/**
 * Removes an input template.
 * @param id The input template id.
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveInputTemplateQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}